import CoupdoeilElement from "./elements/coupdoeil_element"
import { upgradeNativeElement as internalUpgradeNativeElement, downgradeNativeElement } from "./elements/coupdoeil_element"
import './events'

if (customElements.get("coup-doeil") === undefined) {
  customElements.define("coup-doeil", CoupdoeilElement)
}

window.Coupdoeil = {
  upgradeNativeElement(element) {
    if (!element.dataset.popoverOptions) {
      throw 'element is missing Coupdoeil popover dataset'
    }
    internalUpgradeNativeElement(element)
  },
  downgradeNativeElement
}
